export default __webpack_public_path__ + "assets/images/7b9c1a33111d4c0bbf9691f3e175bdec.png";